import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getCompany, ActualizaCompany, TestCompany} from "../../services/company";
import Icon from "../../Icons/general/Icon";
import Switch from "../switch";
//----------------------------------------------------------------------------------------------------------------------
const SectionHeader = ({icon, title, subtitle, right}) =>
   {
     return (
        <div className="border-b border-gray-200 px-6 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-200 text-border flex items-center justify-center">
               <Icon svg={icon} className="w-5 h-5 md:w-6 md:h-6 fill-current"></Icon>
            </div>

            <div>
              <h2 className="font-bold text-base text-gray-600">{title}</h2>
              <p className="text-sm text-gray-500">{subtitle}</p>
            </div>
          </div>

         {right} 
        </div>
     );
    } 
//----------------------------------------------------------------------------------------------------------------------
  const Field = ({label, children, className}) => 
   {
     return (
        <div className={className}>
           <label>{label}</label>
           {children}
        </div>
      );
   }
//-----------------------------------------------------------------------------------------------------------------------
function CompanyView() {
  const [habilita, setHabilita] = useState(true);
  const [habilitat, setHabilitat] = useState(false);
  const { setShowToast, setOpciones } = ErrorContext();
  const [tipodocs, setTipodoc] = useState([])
  const [ciudades, setCiudad] = useState([])
  const [ruta, setRuta] = useState("");
  const [loading, setLoading] = useState(false);
  const [mensajeConexion, setMensajeConexion] = useState("");
  const [tipoMensaje, setTipoMensaje] = useState(""); 
  const [logoFile, setLogoFile] = useState(null);
  const [consultando, setConsultando] = useState(false);
  const [datas, setDatas] = useState({TerceroId:0,
                                     TipoDoc:'', 
                                     NumeroNit:'', 
                                     Chequeo:'', 
                                     NombreComr:'',
                                     Direccion:'',
                                     Email:'',
                                     Telefono:'',
                                     CiudadId:'',
                                     ApiWlss:'N',
                                     UrlWlss:'',
                                     ApkWlss:'',
                                     ClientWlss:'',
                                     NombreCiudad:''})

  
  //--------- Metodo para mostrar las Empresa en la grilla -------------------------------------------------------------
  const fillCompany = async () => 
    {
      setShowToast(false);
      const response = await getCompany();
      if (response) 
        {
           if (response.status === 200) 
            {
              await GenerarRutaArch(response.data.data);

              setDatas({
                ...datas,
                TerceroId: response.data.data.TerceroId,
                TipoDoc: response.data.data.TipoDoc, 
                NumeroNit:response.data.data.NumeroNit,  
                Chequeo:response.data.data.Chequeo,
                NombreComr:response.data.data.NombreComr,
                Direccion:response.data.data.Direccion,
                Email:response.data.data.Email,
                Telefono:response.data.data.Telefono,
                CiudadId:response.data.data.CiudadId,
                ApiWlss:response.data.data.ApiWlss,
                UrlWlss:response.data.data.UrlWlss,
                ApkWlss:response.data.data.ApkWlss,
                ClientWlss:response.data.data.ClientWlss,
                NombreCiudad :response.data.data.NombreCiudad,
              });
              setCiudad(response.data.ciudad);
              setTipodoc(response.data.tipodoc);
            } 
           else 
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
            }
        }
    };
//----------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
      fillCompany();
    }, []);
//----------------------------------------------------------------------------------------------------------------------

const GenerarRutaArch = (Datos) => 
  {
    if (Datos.ArchivoId > 0)
    {
     const NombreArch = Datos.ArchivoId + "_" + Datos.ItemId + "." + Datos.Formato;
     const RutaArch =  `${import.meta.env.BASE_URL}api/static/${Datos.RutaArch}/${NombreArch}`;
     setRuta(RutaArch);
    }
  };
//----------------------------------------------------------------------------------------------------------------------
const handleChange = (e) => 
  {
    const { name, value } = e.target;
    setDatas((prev) => ({
       ...prev,
        [name]: value,
    }));
    setHabilita(false);
  };
//----------------------------------------------------------------------------------------------------------------------
const handleTest = async() => 
  {
    setHabilitat(true);
    setLoading(true);
    setMensajeConexion("Conectando con el servidor...");
    setTipoMensaje("");
    const response = await TestCompany(datas.UrlWlss, datas.ApkWlss, datas.ClientWlss);
    if (response) {
       if (response.status === 200) 
        {
          setTipoMensaje("success");
          setMensajeConexion("Conexión establecida correctamente.");
        } 
       else 
        {
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
          setHabilitat(false);
          setTipoMensaje("error");
          setMensajeConexion("No fue posible establecer la conexión.");
        }
    }
    else
    {
      setTipoMensaje("error");
      setMensajeConexion("No fue posible establecer la conexión.");
    }

    setHabilitat(false);
    setLoading(false);
  };
//----------------------------------------------------------------------------------------------------------------------
const handleAceptar = async () => 
  {
    setHabilita(true);
    setShowToast(false);
    setConsultando(true);

    const formData = new FormData();

    // Agregar todos los campos del objeto
    Object.entries(datas).forEach(([key, value]) => {
      formData.append(key, value ?? "");
     });

    // Agregar la imagen
    if (logoFile) {
      formData.append("files", logoFile);
      }
    
    const response = await ActualizaCompany(formData);
    if (response) {
       if (response.status === 200) 
        {
         setConsultando(false);
         setShowToast(true);
         setOpciones({
            type: "Success",
            message: "Guardado exitosamente",
            active: true,
          });

         setHabilita(true);
         
        } 
       else 
        {
          setConsultando(false);
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
          setHabilita(false);
 
        }
    }
  };  
//----------------------------------------------------------------------------------------------------------------------
const handleLogoChange = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  if (file.size > 2 * 1024 * 1024) {
    alert("La imagen no puede superar 2 MB");
    return;
  }

  setLogoFile(file);
  setRuta(URL.createObjectURL(file));
  setHabilita(false);
};  
//----------------------------------------------------------------------------------------------------------------------
  return (
    <>
      <main className="flex-1 p-8  w-full max-w-6xl ">
        <div className="flex justify-between items-start mb-6 ">
          <div>
            <h1 className="text-2xl font-bold text-gray-600">Datos de la Empresa</h1>
            <p className="text-gray-500 text-sm">
              Administra la información general de tu empresa y su configuración de conexión.
            </p>
          </div>

          <div className="flex gap-3">
            <button className="flex flex-row bg-default text-white rounded-md px-5 py-2 gap-1 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none" onClick={handleAceptar} disabled={habilita}>
              <Icon svg="save" className="w-[1.5rem] h-[1.5rem]"></Icon> Guardar
            </button>
          </div>
        </div>

        {/* Información general */}
        <section className="bg-white border border-gray-200 rounded-xl mb-4">
          <SectionHeader
             icon="note"
             title="Información General"
             subtitle="Datos básicos de identificación y contacto de la empresa."
          />

          <div className="p-6 grid grid-cols-[240px_1fr] gap-8">
            <div>
              <label className="label">Logo de la empresa</label>

           <div className="border border-dashed rounded-lg h-[12.5rem] w-[12.5rem] flex flex-col justify-center items-center m-1">
             {ruta !=='' ? (<img src={ruta} className="w-full h-full object-cover rounded-full"></img>):
                (<div>
                   <p className="font-semibold text-gray-200">Sin imagen</p>
                   <p className="text-xs text-gray-300">Máx. 2 MB</p>
                 </div>  
                )
              }  
            </div>
            <input
                id="logoEmpresa"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleLogoChange}
            />
            <label
              htmlFor="logoEmpresa"
              className="w-[12.5rem] flex flex-row cursor-pointer select-none border border-sidebar text-default rounded-md mt-4 px-4 py-2 gap-2 items-center justify-center text-center"
            >
              <Icon svg="upload" className="flex w-[1.7rem] h-[1.7rem] fill-default" />
              Cargar imagen
            </label>
         </div>

            <div className="grid grid-cols-12 gap-5">
              <Field className="col-span-4" label="Tipo de documento">
                <select className="input" value={datas.TipoDoc} disabled>
                  <option value="">Seleccione...</option>
                    {tipodocs.map((t, index) => (
                       <option key={index} value={t.Codigo}>
                          {t.NombreParm}
                        </option>
                  ))}
                </select>
              </Field>

              <Field className="col-span-5" label="Identificación">
                <input type="text" className="input" value={datas.NumeroNit} readOnly/>
              </Field>

              <Field className="col-span-3" label="Dígito de verificación">
                <input type="text" className="input" value={datas.Chequeo} readOnly/>
              </Field>

              <Field className="col-span-12" label="Nombre comercial">
                <input type="text" className="input" value={datas.NombreComr ?? ""} name="NombreComr" onChange={handleChange}/>
              </Field>

              <Field className="col-span-6" label="Dirección">
                <input type="text" className="input" value={datas.Direccion} name="Direccion" onChange={handleChange}/>
              </Field>

              <Field className="col-span-6" label="Ciudad">
                <select className="input" value={datas.CiudadId} name="CiudadId" onChange={handleChange}>
                  <option value="">Seleccione...</option>
                  {ciudades.map((t, index) => (
                    <option key={index} value={t.CiudadId}>
                      {t.NombreCiudad}
                    </option>
                  ))}
                </select>
              </Field>

              <Field className="col-span-6" label="Email">
                <input type="text" className="input" value={datas.Email} name="Email" onChange={handleChange}/>
              </Field>

              <Field className="col-span-6" label="Teléfono">
                <input type="text" className="input" value={datas.Telefono} name="Telefono" onChange={handleChange}/>
              </Field>
            </div>
          </div>
        </section>

        {/* API */}
        <section className="bg-white border border-gray-200 rounded-xl mb-4">
          <SectionHeader
            icon="link"
            title="Configuración de Conexión API (Opcional)"
            subtitle="Configura los datos de conexión si tu sistema se integra con un servicio externo."
            right={
                   <div className="flex items-center gap-3">
                      <span className="text-sm">¿Usa conexión API?</span>
                      <Switch name="ApiWlss" value={datas.ApiWlss} onChange={handleChange}/>
                   </div>
                  }
          />
          <div className="p-6 grid grid-cols-12 gap-5">
              {/* Columna izquierda */}
              <div className="col-span-8 space-y-4">
                <Field label="URL de la API">
                  <input type="text" className="input" placeholder="https://api.midominio.com" value={datas.UrlWlss} name="UrlWlss" onChange={handleChange} disabled={datas.ApiWlss!=='S'}/>
                </Field>

                <Field label="Token / Clave">
                  <input type="text" className="input" placeholder="Ingresa el token o clave de acceso" value={datas.ApkWlss} name="ApkWlss" onChange={handleChange} disabled={datas.ApiWlss!=='S'}/>
                </Field>

                <Field label="Cliente Id">
                  <input type="text" className="input" placeholder="Ingresa el usuario" value={datas.ClientWlss} name="ClientWlss" onChange={handleChange} disabled={datas.ApiWlss!=='S'}/>
                </Field>
              </div>

              {/* Columna derecha */}
              <div className="col-span-4 border rounded-lg p-4 flex flex-col">
                <p className="font-semibold">Probar conexión</p>

                <p className="text-sm text-gray-500 mt-2">
                  Verifica que la información de conexión sea correcta.
                </p>

                <div className="mt-2">
                  <button className="flex items-center gap-2 border border-sidebar text-sidebar rounded-md px-4 py-2" onClick={handleTest} disabled={habilitat}>
                    <Icon
                      svg="signal"
                      className="w-[1.2rem] h-[1.2rem] fill-default"
                    />
                    {loading ? "Conectando..." : "Probar conexión"}
                  </button>
                   {loading && (
                     <div className="text-sm flex items-center gap-2 mt-3">
                        <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                        <span>Probando conexión...</span>
                     </div>
                    )}

                   {mensajeConexion && !loading && (
                      <div className={`mt-3 text-sm ${tipoMensaje === "success" ? "text-green-600": "text-red-600"}`}>
                         {mensajeConexion}
                      </div>
                    )}
                </div>
              </div>
          </div>
        </section>

      </main>

      {consultando && (
          <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-blue-600 rounded-full mx-auto mb-4"></div>
              <p className="text-gray-700 font-medium">Registrando Datos...</p>
              <p className="text-sm text-gray-500">Por favor espere</p>
            </div>
          </div>
       )}

   </>
  )
}
export default CompanyView;



